import { Routes } from '@angular/router';
import { BaseLayoutComponent } from './layouts/in-app-layout/base-layout.component';
import { HomeComponent } from './pages/home/home.component';
import { MachineListComponent } from './pages/machine-list/machine-list.component';
import { PendingSessionComponent } from './pages/pending-session/pending-session.component';
import { SessionHistoryComponent } from './pages/session-history/session-history.component';
import { WebRtcConnectionWindowComponent } from './components/webrtc-connection-window/webrtc-connection-window.component';

export const routes: Routes = [
  {
    path: 'app',
    title: 'Home',
    component: BaseLayoutComponent,
    children: [
      { path: '', title: 'RDP Client', component: HomeComponent },
      { path: 'machine-list', title: 'Machines', component: MachineListComponent },
      { path: 'pending-sessions', title: 'Pending Sessions', component: PendingSessionComponent },
      { path: 'session-history', title: 'Session History', component: SessionHistoryComponent },
      { path: 'connection/:sessionId', title: 'Connection', component: WebRtcConnectionWindowComponent },
    ],
  },
  { path: '', redirectTo: 'app', pathMatch: 'full' },
];
